export default build =>
    build.mutation({
        query(payload) {         
            return {
                url: '/product/addProduct',
                method: 'POST',
                body: payload,
            };
        },
        invalidatesTags: ['allProducts']       
    })
